import { TYRE_POSITION } from "../../../../util/tyre";

export const isOnCarTyre = position => position <= TYRE_POSITION.CAR_REAR_RIGHT;

export const isInStorageTyre = position => position > TYRE_POSITION.CAR_REAR_RIGHT && position <= TYRE_POSITION.STORAGE_REAR_RIGHT;

export const isOnTruckTyre = position => TYRE_POSITION.IS_TRUCK_TYRE(position);

export const groupTruckTyreByAxle = (truckTyres, t) => {
  const groupedTruckTyres = {};

  truckTyres.forEach(tyre => {
    if (groupedTruckTyres[`${t("cc_axle").message || "Axle"}${tyre.truck_axle}`]) groupedTruckTyres[`${t("cc_axle").message || "Axle"}${tyre.truck_axle}`].push(tyre);
    else groupedTruckTyres[`${t("cc_axle").message || "Axle"}${tyre.truck_axle}`] = [tyre];
  });

  return Object.entries(groupedTruckTyres);
};

export const getTyreDescription = tyre => {
  if (!tyre) return "";

  return !tyre.description.includes(`${tyre.carry_capacity}/${tyre.speed}`) && !tyre.description.includes(`${tyre.carry_capacity}${tyre.speed}`)
    ? `${tyre.description} ${tyre.carry_capacity}${tyre.speed}`
    : tyre.description;
};

export const normalizeTyreDescription = tyre => {
  const carryCapacitySpeed = `${tyre.carry_capacity}${tyre.speed}`;
  const widthHeight = `${tyre.width}/${tyre.height}`;

  if (!tyre.description.includes(widthHeight)) return `${widthHeight} R${tyre.size} ${tyre.description} ${carryCapacitySpeed}`;

  const modelName = tyre.description
    .split(" ")
    .filter(t => {
      return (
        t.toLowerCase() !== tyre.manufacturer.toLowerCase() &&
        !t.includes(widthHeight) &&
        !t.includes(`R${tyre.size}`) &&
        !t.includes(carryCapacitySpeed) &&
        !t.includes(`${tyre.carry_capacity}/`)
      );
    })
    .join(" ");

  if (modelName) return `${widthHeight} R${tyre.size} ${modelName} ${carryCapacitySpeed}`;
  return `${widthHeight} R${tyre.size} ${carryCapacitySpeed}`;
};

export const getFullTyreDescription = (tyre, isTyreNet) => {
  if (!tyre) return "";
  if (isTyreNet) return normalizeTyreDescription(tyre);
  return getTyreDescription(tyre);
};

export const getTyrePosition = (r, hideTyrePositionLabels, t) => {
  let title = r.title;
  if (r.tyre_position > 0) {
    title = hideTyrePositionLabels ? "" : (r.tyre_position < 5 ? t("cc_Car_tyre").message || "Car tyre" : t("cc_Storage_tyre").message || "Storage tyre") + ": ";

    switch (r.tyre_position) {
      case TYRE_POSITION.CAR_FRONT_LEFT:
      case TYRE_POSITION.STORAGE_FRONT_LEFT:
        title += t("cc_front_left").message || "front left";
        break;

      case TYRE_POSITION.CAR_FRONT_RIGHT:
      case TYRE_POSITION.STORAGE_FRONT_RIGHT:
        title += t("cc_front_right").message || "front right";
        break;

      case TYRE_POSITION.CAR_REAR_LEFT:
      case TYRE_POSITION.STORAGE_REAR_LEFT:
        title += t("cc_rear_left").message || "rear left";
        break;

      case TYRE_POSITION.CAR_REAR_RIGHT:
      case TYRE_POSITION.STORAGE_REAR_RIGHT:
        title += t("cc_rear_right").message || "rear right";
        break;

      default:
        break;
    }
  }

  return title;
};

export const getTruckTyrePositon = (position, t) => {
  switch (position) {
    case TYRE_POSITION.TRUCK_LEFT:
      return t("left").message || "Left";

    case TYRE_POSITION.TRUCK_RIGHT:
      return t("right").message || "Right";

    case TYRE_POSITION.TRUCK_EXTERIOR_LEFT:
      return t("exterior_left").message || "Exterior Left";

    case TYRE_POSITION.TRUCK_EXTERIOR_RIGHT:
      return t("exterior_right").message || "Exterior Right";

    case TYRE_POSITION.TRUCK_INTERIOR_LEFT:
      return t("interior_left").message || "Interior Left";

    case TYRE_POSITION.TRUCK_INTERIOR_RIGHT:
      return t("interior_right").message || "Interior Right";

    case TYRE_POSITION.TRUCK_SPARE:
      return t("spare_tyre").message || "Spare Tyre";
    default:
      break;
  }
};

export const getTyreSize = tyre => {
  if (!tyre) return "";
  return `${tyre.width}-${tyre.height}-R${tyre.size}`;
};
